import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@kambria/kambria-lego';
import papa from 'papaparse';

import CoreTransferFrom from './coreTransferFrom';


class TransferFrom extends Component {
  constructor() {
    super();

    this.state = {
      dataset: [{ from: '', to: '', amount: '' }]
    }
  }

  more = () => {
    let newDataset = this.state.dataset;
    newDataset.push({ from: '', to: '', amount: '' });
    this.setState({ dataset: newDataset });
  }

  clear = () => {
    this.setState({ dataset: [] }, () => {
      this.setState({ dataset: [{ from: '', to: '', amount: '' }] });
    });
  }

  handleFile = () => {
    let self = this;
    let config = {
      delimiter: ',',
      complete: function (results) {
        if (results.errors.length > 0) return console.error('Cannot handle this file.');
        let newDataset = results.data.map(tx => {
          return {
            from: tx[0],
            to: tx[1],
            amount: tx[2]
          }
        });
        self.setState({ dataset: [] }, () => {
          self.setState({ dataset: newDataset });
        });
      }
    }

    let file = this.refs.csvFile.files[0];
    if (!file) return console.error('Cannot handle empty file.');
    papa.parse(file, config);
  }


  renderCoreTransferFrom = (dataset) => {
    return dataset.map((item, i) => {
      return <CoreTransferFrom key={i} from={item.from} to={item.to} amount={item.amount} />
    });
  }

  render() {
    return (
      <div className="container">
        <h2 className="title">Transfer From <i className="sync-btn fas fa-sync-alt" onClick={this.clear} /></h2>
        <table className="mx-auto w-100 position-relative" style={{ "top": "72px" }}>
          {this.renderCoreTransferFrom(this.state.dataset)}
          <tbody>
            <tr>
              <td className="pr-0 pt-4">
                <Button onClick={this.more} type="secondary" size="sm" customStyle={{ "height": "40px" }}>+</Button>
              </td>
            </tr>
          </tbody>
        </table>
        <h3 className="upload-csv">Upload CSV</h3>
        <p className="download d-block w-100">The CSV data should be in form of <code>source_address,target_address,value</code> (The elimiter is <code>,</code>). New records should be presented after  a line break.</p>
        <Button type="primary" size="sm" onClick={() => { this.refs.csvFile.click() }}>Upload</Button>
        <input id='csvFile' type='file' accept=".csv" onChange={this.handleFile} ref="csvFile" hidden />
        <h3 className="definition">What is "Transfer From"?</h3>
        <p className="description d-block w-100 text-left">You are sending a number of token, the source address granted, to the target address.</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  kat: state.kat
});

const mapDispatchToProps = dispatch => bindActionCreators({
  // Null
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferFrom);